import './eventIndexController.js';
import './eventService.js';

import 'Sass/views/_events.scss';